import {
	createRouter,
	createWebHashHistory
} from 'vue-router'

import homeIndex from '../components/homeIndex.vue'
import overView from '../components/overView.vue'
import investInfo from '../components/investInfo.vue'
import doingBusiness from '../components/doingBusiness.vue'
import webLink from '../components/webLink.vue'
import mapView from '../components/MapView.vue'
import mapPosition from '../components/MapPosition.vue'
import articleList from '../components/articleList.vue'
import dynamicList from '../components/dynamicList.vue'
import policyList from '../components/policyList.vue'
import articleDetail from '../components/articleDetail.vue'
import dynamicDetail from '../components/dynamicDetail.vue'
import policyDetail from '../components/policyDetail.vue'
import parkList from '../components/parkList.vue'
import massifsDetail from '../components/massifsDetail.vue'
const router = createRouter({
	history: createWebHashHistory(),
	routes: [{
			path: '/',
			name: 'homeIndex',
			component: homeIndex
		},
		{
			path: '/overView',
			name: 'overView',
			component: overView
		},
		{
			path: '/webLink',
			name: 'webLink',
			component: webLink
		},
		{
			path: '/investInfo',
			name: 'investInfo',
			component: investInfo
		},
		{
			path: '/doingBusiness',
			name: 'doingBusiness',
			component: doingBusiness
		},
		{
			path: '/articleList',
			name: 'articleList',
			component: articleList
		},
		{
			path: '/dynamicList',
			name: 'dynamicList',
			component: dynamicList
		},
		{
			path: '/policyList',
			name: 'policyList',
			component: policyList
		},
		{
			path: '/articleDetail',
			name: 'articleDetail',
			component: articleDetail
		},
		{
			path: '/dynamicDetail',
			name: 'dynamicDetail',
			component: dynamicDetail
		},
		{
			path: '/policyDetail',
			name: 'policyDetail',
			component: policyDetail
		},
		{
			path: '/parkList',
			name: 'parkList',
			component: parkList
		},
		{
			path: '/parkIntro',
			name: 'parkIntro',
			component: () => import('../components/parkIntro.vue')
		},
		{
			path: '/massifsList',
			name: 'massifsList',
			component: () => import('../components/massifsList.vue')
		},
		{
			path: '/massifsDetail',
			name: 'massifsDetail',
			component: massifsDetail
		},
		{
			path: '/mapPosition',
			name: 'mapPosition',
			component: mapPosition
		},
		{
			path: '/mapView',
			name: 'mapView',
			component: mapView
		},
		{
			path: '/projectSel',
			name: 'projectSel',
			component: () => import('../components/projectSel.vue')
		},
		{
			path: '/projectDetail',
			name: 'projectDetail',
			component: () => import('../components/projectDetail.vue')
		},
	],
	scrollBehavior(to, from, savedPosition) {
		// 
		if (savedPosition) {
			return savedPosition
		} else {
			return {
				top: 0
			}
		}

	}
})

export default router